export const environment = {
  production: false,
  apiUrl: 'https://api.dev.actor.codev.gr/api/',
  //apiUrl: 'http://192.168.21.20:8081/api/',
  //fastAPIUrl: 'http://127.0.0.1:8000'
  fastAPIUrl:'http://192.168.21.20:8181'
  //fastAPIUrl: 'http://192.168.132.76:8082'
};